import { z } from 'zod';

import type { TFunction } from 'i18next';

import {
  customFieldValuesSchema,
  refineRequiredCustomFields,
  requiredSelect,
} from './common';

// Client and guest stay optional on purpose — the backend accepts a booking with neither.
export const createBookingReservationSchema = (
  t: TFunction,
  requiredCustomFieldIds: number[] = [],
) =>
  z
    .object({
      staff_id: requiredSelect(t),
      service_id: requiredSelect(t),
      starts_at: z.string().min(1, { message: t('validation_required') }),
      client_id: z.string(),
      guest_info: z.string(),
      note: z.string(),
      staff_comment: z.string(),
      custom_field_values: customFieldValuesSchema,
    })
    .superRefine(refineRequiredCustomFields(t, requiredCustomFieldIds));

export type BookingReservationFormValues = z.infer<
  ReturnType<typeof createBookingReservationSchema>
>;

export const createRescheduleBookingReservationSchema = (t: TFunction) =>
  z.object({
    staff_id: requiredSelect(t),
    location_id: requiredSelect(t),
    date: z.string().min(1, { message: t('validation_required') }),
    starts_at: z.string().min(1, { message: t('validation_required') }),
    guest_info: z.string(),
    note: z.string(),
    staff_comment: z.string(),
  });

export type RescheduleBookingReservationFormValues = z.infer<
  ReturnType<typeof createRescheduleBookingReservationSchema>
>;

export const CANCELLATION_REASON_MAX_LENGTH = 500;

export const createCancelBookingReservationSchema = (t: TFunction) =>
  z.object({
    cancellation_reason: z
      .string()
      .trim()
      .min(1, { message: t('Enter the cancellation reason') })
      .max(CANCELLATION_REASON_MAX_LENGTH, {
        message: t('The cancellation reason is too long'),
      }),
  });

export type CancelBookingReservationFormValues = z.infer<
  ReturnType<typeof createCancelBookingReservationSchema>
>;
